module.exports = __webpack_public_path__ + "img/popup-img.bdf861ea.svg";